// @flow

const STORAGE_ITEM_LOADING = 'STORAGE_ITEM_LOADING';
const STORAGE_ITEM_LOADED = 'STORAGE_ITEM_LOADED';

export type StorageItemLoadingEvent = {|
  type: typeof STORAGE_ITEM_LOADING,
  payload: {key: string},
|};

export type StorageItemLoadedEvent = {|
  type: typeof STORAGE_ITEM_LOADED,
  payload: {key: string, value: any},
|};

export const storageItemLoading = (key: string): StorageItemLoadingEvent => ({
  type: STORAGE_ITEM_LOADING,
  payload: {key},
});

export const storageItemLoaded = (
  key: string,
  value: any,
): StorageItemLoadedEvent => ({
  type: STORAGE_ITEM_LOADED,
  payload: {key, value},
});

export type StorageEvent = StorageItemLoadedEvent | StorageItemLoadingEvent;

export type StorageEventDispatcher = (event: StorageEvent) => mixed;

export type StorageItem = {|
  isLoading: boolean,
  value: any,
|};

export type StorageReducerState = {|
  items: {[key: string]: StorageItem},
|};

export const StorageReducer = (
  state: StorageReducerState,
  event: StorageEvent,
) => {
  switch (event.type) {
    case STORAGE_ITEM_LOADING:
      return {
        items: {
          ...state.items,
          [event.payload.key]: {isLoading: true},
        },
      };
    case STORAGE_ITEM_LOADED:
      return {
        items: {
          ...state.items,
          [event.payload.key]: {isLoading: false, value: event.payload.value},
        },
      };
    default:
      throw new Error(`Unknown storage action type ${event.type}`);
  }
};
